import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BrandLogo from '../components/brand/BrandLogo';

const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-zinc-50 p-6 text-center dark:bg-[#07040f] dark:bg-aura-radial">
      <BrandLogo to="/" size="lg" showWordmark showTagline stacked />
      <p className="mt-8 text-6xl font-bold text-gold-400">404</p>
      <h2 className="mt-4 font-display text-xl font-medium text-zinc-900 dark:text-zinc-100">
        {t('errors.notFoundPage.title')}
      </h2>
      <p className="mt-2 max-w-sm text-sm text-zinc-600 dark:text-zinc-500">
        {t('errors.notFoundPage.description')}
      </p>
      <Link
        to="/"
        className="mt-8 rounded-lg bg-gradient-to-r from-aura-600 to-glow-600 px-6 py-2.5 text-sm font-medium text-white hover:from-aura-500 hover:to-glow-500"
      >
        {t('errors.notFoundPage.goHome')}
      </Link>
    </div>
  );
};

export default NotFoundPage;
